<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getBallotpediaUrl } from '../utils/partyUtils';
import { useNavigation } from '@/composables/useNavigation';

const props = defineProps<{ name: string }>();
const { t } = useI18n();

const { openUrl } = useNavigation();
const href = computed(() => getBallotpediaUrl(props.name));
const tooltip = computed(() => t('viewBallotpedia', { name: props.name }));

const handleClick = () => {
  if (!href.value) return;
  openUrl(href.value, { target: '_blank' });
};
</script>

<template>
  <a
    v-if="href"
    :href="href"
    :title="tooltip"
    target="_blank"
    rel="noopener noreferrer"
    v-bind="$attrs"
    @click.prevent="handleClick"
  >
    <slot />
  </a>
</template>
